import ConfluenceConnected from '../../../containers/source-integration/independent-integrations/confluence'

export const confluence = {
  component: ConfluenceConnected,
  data: {
    title: 'Spectral Confluence Scanner',
    tileKey: 'confluence',
  },
}
